import { IoIosSwap } from 'react-icons/io';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { LuDollarSign } from 'react-icons/lu';
import { BsDownload } from 'react-icons/bs';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useSession } from '@/contexts/LitSessionProvider';
import { useSwap } from '@/contexts/SwapProvider';
import MobileDeposit from '@/components/deposit/MobileDeposit';
import classNames from '@/lib/misc/classNames';
import SlidingModal from '../SlidingModal';
import TokenToSend from '@/components/portfolio/desktop/TokenToSend';
import { useTouchHandlerName } from '@/hooks/utilities/use-mobile';
const MobileNav = () => {
  const router = useRouter();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSendModalOpen, setSendModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const {
    PKP
  } = useSession();
  const {
    resetAssets
  } = useSwap();
  const [disableSwap] = useLocalStorage('disableSwap', false);
  return <div className='py-2 px-4 w-full flex mt-3 justify-between text-xs' data-sentry-component="MobileNav" data-sentry-source-file="MobileNav.tsx">
      <NavItem icon={<LuDollarSign className='h-4 w-4' />} className={disableSwap ? 'w-full' : 'w-2/4'} label='Withdraw' onClick={() => setSendModalOpen(true)} data-sentry-element="NavItem" data-sentry-source-file="MobileNav.tsx" />

      <NavItem icon={<BsDownload className='h-4 w-4' />} className={disableSwap ? 'w-full' : 'w-2/4'} label='Deposit' onClick={() => {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.home.goToDeposit,
        category: CATEGORIES.home
      });
      toggleModal();
    }} data-sentry-element="NavItem" data-sentry-source-file="MobileNav.tsx" />
      {!disableSwap && <NavItem icon={<IoIosSwap size={18} />} label='Swap' onClick={() => {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.home.goToTrade,
        category: CATEGORIES.home
      });
      resetAssets();
      router.push('/trade/');
    }} />}
      <MobileDeposit isModalOpen={isModalOpen} setIsModalOpen={toggleModal} data-sentry-element="MobileDeposit" data-sentry-source-file="MobileNav.tsx" />
      <SlidingModal isOpen={isSendModalOpen} onClose={() => setSendModalOpen(false)} data-sentry-element="SlidingModal" data-sentry-source-file="MobileNav.tsx">
        <TokenToSend data-sentry-element="TokenToSend" data-sentry-source-file="MobileNav.tsx" />
      </SlidingModal>
    </div>;
};
const NavItem = ({
  icon,
  label,
  onClick,
  className
}: {
  icon: any;
  label: string;
  onClick?: any;
  className?: string;
}) => {
  const touchHandlerName = useTouchHandlerName();
  return <div className={classNames('flex flex-col items-center w-2/4 mx-1', className)} {...{
    [touchHandlerName]: () => {
      onClick();
    }
  }} data-sentry-component="NavItem" data-sentry-source-file="MobileNav.tsx">
      <div className='ta-c justify-center bg-genius-blue text-genius-cream rounded-[20px] font-bold h-12 flex items-center w-full'>
        <div>{icon}</div>
      </div>
      <p className='text-genius-cream mt-0.5'>{label}</p>
    </div>;
};
export default MobileNav;